<!-- single-tree.component.html -->
<div class="single-tree-container"
     [class.bilingual-mode]="selectedLanguage === 'bilingual'"
     [class.hindi-only-mode]="selectedLanguage === 'hindionly'"
     [class.english-only-mode]="selectedLanguage === 'englishonly'"
     [class.edit-mode-active]="isEditMode">
    <mat-toolbar class="pane-header">
        <!-- Layout Switcher slot -->
        <div class="layout-switcher-container">
            <ng-content select="app-layout-switcher[hideSearch]"></ng-content>
        </div>

        <!-- Search functionality - IMPROVED -->
        <div class="search-container" [class.has-filter]="isSearchExpanded">
            <!-- Search toggle button -->
            <button
                    mat-icon-button
                    class="toggle-search-button"
                    [class.active]="isSearchExpanded"
                    (click)="toggleSearch()"
                    matTooltip="Search">
                <mat-icon>{{ isSearchExpanded ? 'search_off' : 'search' }}</mat-icon>
            </button>

            <!-- Search input container -->
            <div class="search-input-container" [class.expanded]="isSearchExpanded">
                <mat-icon class="search-icon">search</mat-icon>
                <input
                    #searchInput
                    class="search-input"
                    type="text"
                    placeholder="Search..."
                    [(ngModel)]="searchTerm"
                    (input)="onSearchInput()"
                />
                <button
                        *ngIf="searchTerm"
                        mat-icon-button
                        class="clear-search"
                        (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- Filter toggle -->
            <mat-slide-toggle
                    *ngIf="isSearchExpanded"
                    class="filter-toggle"
                    [checked]="filterMode"
                    (change)="toggleFilterMode($event)"
                    color="primary">
                Filter
            </mat-slide-toggle>
        </div>
        <!-- Language toggle menu - MORE PROMINENT PLACEMENT -->
        <div class="language-selector-container">
            <button mat-button class="language-dropdown" [matMenuTriggerFor]="languageMenu">
                <span>{{ selectedLanguage === 'bilingual' ? 'Bilingual' : (selectedLanguage === 'englishonly' ? 'English Only' : 'Hindi Only') }}</span>
            </button>
            <mat-menu #languageMenu="matMenu" class="language-menu-panel">
                <button mat-menu-item *ngFor="let option of languageOptions"
                        (click)="onLanguageChange(option.value, $event)"
                        [class.selected]="selectedLanguage === option.value"
                        class="language-option">
                    {{ option.label }}
                </button>
            </mat-menu>
            
            <!-- Refresh Button -->
            <button mat-icon-button (click)="refreshTopicTree()" matTooltip="Refresh Topic Tree" [disabled]="isRefreshInProgress">
                <mat-icon>refresh</mat-icon>
            </button>
            
            <!-- Add Subject Button - Only shown for internal users -->
            <button mat-icon-button (click)="addSubject()" matTooltip="Create New Subject" *ngIf="isInternalUser && isEditMode">
                <mat-icon>add_box</mat-icon>
            </button>
        </div>

        <!-- Edit Tree toggle - Only visible for internal users in default view -->
        <div class="edit-tree-toggle-container" *ngIf="isInternalUser">
            <mat-slide-toggle
                    class="edit-tree-toggle"
                    [checked]="isEditMode"
                    (change)="toggleEditMode($event)"
                    color="primary">
                Edit
            </mat-slide-toggle>
        </div>

        <span class="spacer"></span>
        <div class="layout-switcher-container">
            <button mat-icon-button (click)="toggleAllNodes()" matTooltip="{{ isTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                <mat-icon>{{ isTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
            </button>
        </div>
        <!-- Tree expand/collapse controls -->

        <!-- Mode toggle buttons - VERTICAL LAYOUT -->
        <div class="mode-toggle-container">
            <button mat-button
                    class="mode-toggle-button"
                    [class.active-mode]="p1Mode === 'topicwise'"
                    (click)="onModeChange('topicwise')">
                Topicwise
            </button>
            <button mat-button
                    class="mode-toggle-button"
                    [class.active-mode]="p1Mode === 'yearwise'"
                    (click)="onModeChange('yearwise')">
                Yearwise
            </button>
        </div>

        <span class="spacer"></span>

    </mat-toolbar>

    <div class="pane-content">
        <!-- TOPICWISE TREE -->
        <ng-container *ngIf="p1Mode === 'topicwise'">
            <div class="tree-container">
                <!-- Loading indicators -->
                <div *ngIf="isLoadingSubjects" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading subjects...</span>
                </div>

                <div *ngIf="isLoadingSections" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading sections...</span>
                </div>

                <div *ngIf="isLoadingTopics" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading topics...</span>
                </div>

                <div *ngIf="isLoadingSubtopics" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading subtopics...</span>
                </div>

                <!-- Tree actions toolbar -->
                <div class="tree-actions-toolbar" *ngIf="!isLoadingTopics">
                    <span class="spacer"></span>

                    <!-- Enhanced expand/collapse all button with icon -->
                    <button mat-icon-button (click)="toggleAllNodes()" matTooltip="{{ isTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                        <mat-icon>{{ isTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                    </button>
                </div>

                <!-- Tree view -->
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="full-tree">
                    <!-- Leaf node template -->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="24">
                        <div class="node-content-container"
                            [class.selected]="selectedNodePath.includes(node)"
                            [class.last-selected]="node === selectedNode"
                            (click)="selectNode(node)">
                            
                          <!-- Normal display -->
                          <span class="node-content" [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                          
                          <!-- Edit button (only visible when edit mode is active) -->
                          <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">
                              <!-- Edit options directly visible on hover, no need to click first -->
                              <div class="edit-options-container">
                                  <button *ngIf="canAddNode(node)" mat-icon-button 
                                          class="add-node-button" 
                                          (click)="addNode(node)"
                                          matTooltip="Add sub-item">
                                      <mat-icon>add_circle</mat-icon>
                                  </button>
                                  <button mat-icon-button 
                                          class="rename-node-button" 
                                          (click)="editNode(node)"
                                          matTooltip="Rename">
                                      <mat-icon>edit_note</mat-icon>
                                  </button>
                                  <button mat-icon-button 
                                          class="delete-node-button" 
                                          (click)="deleteNode(node)"
                                          matTooltip="Delete">
                                      <mat-icon>delete</mat-icon>
                                  </button>
                              </div>
                          </div>
                        </div>
                    </mat-tree-node>

                    <!-- Parent node template -->
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                        <div class="mat-tree-node"
                            [class.selected]="selectedNodePath.includes(node)"
                            [class.last-selected]="node === selectedNode"
                            (click)="selectNode(node)">
                            <!-- Node content container first -->
                            <div class="node-content-container">
                              <!-- Normal display -->
                              <span class="node-content" [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                              
                              <!-- Edit button (only visible when edit mode is active) -->
                              <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">
                                  <!-- Edit options directly visible on hover, no need to click first -->
                                  <div class="edit-options-container">
                                      <button *ngIf="canAddNode(node)" mat-icon-button 
                                              class="add-node-button" 
                                              (click)="addNode(node)"
                                              matTooltip="Add sub-item">
                                          <mat-icon>add_circle</mat-icon>
                                      </button>
                                      <button mat-icon-button 
                                              class="rename-node-button" 
                                              (click)="editNode(node)"
                                              matTooltip="Rename">
                                          <mat-icon>edit_note</mat-icon>
                                      </button>
                                      <button mat-icon-button 
                                              class="delete-node-button" 
                                              (click)="deleteNode(node)"
                                              matTooltip="Delete">
                                          <mat-icon>delete</mat-icon>
                                      </button>
                                  </div>
                              </div>
                            </div>

                            <!-- Toggle button moved to the right -->
                            <button mat-icon-button class="toggle-button" [attr.aria-label]="'Toggle ' + node.name"
                                    (click)="toggleNode($event, node)">
                                <mat-icon>{{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}</mat-icon>
                            </button>
                        </div>
                        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
        </ng-container>

        <!-- YEARWISE TREE - Similar edit for the yearwise section -->
        <ng-container *ngIf="p1Mode === 'yearwise'">
            <div class="tree-container">
                <!-- Loading indicators -->
                <div *ngIf="isLoadingSubjects" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading exams...</span>
                </div>

                <!-- Tree actions toolbar -->
                <div class="tree-actions-toolbar" *ngIf="!isLoadingTopics">
                    <span class="spacer"></span>

                    <!-- Enhanced expand/collapse all button with icon -->
                    <button mat-icon-button (click)="toggleAllYearwiseNodes()" matTooltip="{{ isYearwiseTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                        <mat-icon>{{ isYearwiseTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                    </button>
                </div>

                <!-- Split view for yearwise tree and years -->
                <div class="yearwise-split-view">
                    <!-- Yearwise exams and papers tree -->
                    <div class="yearwise-tree-section">
                        <mat-tree [dataSource]="yearwiseDataSource" [treeControl]="yearwiseTreeControl" class="full-tree">
                            <!-- LEAF NODE (Papers) -->
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                                        [matTreeNodePaddingIndent]="node.level * 16"
                                        [attr.ng-reflect-level]="node.level"
                                        [attr.ng-reflect-padding-indent]="node.level * 16"
                                        [class.selected]="selectedYearwiseNodePath.includes(node)"
                                        [class.last-selected]="node === selectedYearwiseNode">
                                <!-- Normal display -->
                                <span (click)="onYearwiseNodeSelect(node)"
                                    [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                                
                                <!-- Edit button (only visible when edit mode is active) -->
                                <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">
                                    <!-- Edit options directly visible on hover, no need to click first -->
                                    <div class="edit-options-container">
                                        <button *ngIf="canAddNode(node)" mat-icon-button 
                                                class="add-node-button" 
                                                (click)="addNode(node)"
                                                matTooltip="Add sub-item">
                                            <mat-icon>add_circle</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                                class="rename-node-button" 
                                                (click)="editNode(node)"
                                                matTooltip="Rename">
                                            <mat-icon>edit_note</mat-icon>
                                        </button>
                                        <button mat-icon-button 
                                                class="delete-node-button" 
                                                (click)="deleteNode(node)"
                                                matTooltip="Delete">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-tree-node>

                            <!-- INTERNAL NODE WITH CHILDREN -->
                            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasYearwiseChild">
                                <!-- Node content with toggle button -->
                                <div class="mat-tree-node"
                                    [class.selected]="selectedYearwiseNodePath.includes(node)"
                                    [class.last-selected]="node === selectedYearwiseNode">
                                    <!-- Toggle button for expanding/collapsing node -->
                                    <button mat-icon-button matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{yearwiseTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                    </button>

                                    <!-- Normal display -->
                                    <span (click)="onYearwiseNodeSelect(node)"
                                        [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                                    
                                    <!-- Edit button (only visible when edit mode is active) -->
                                    <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">
                                        <!-- Edit options directly visible on hover, no need to click first -->
                                        <div class="edit-options-container">
                                            <button *ngIf="canAddNode(node)" mat-icon-button 
                                                    class="add-node-button" 
                                                    (click)="addNode(node)"
                                                    matTooltip="Add sub-item">
                                                <mat-icon>add_circle</mat-icon>
                                            </button>
                                            <button mat-icon-button 
                                                    class="rename-node-button" 
                                                    (click)="editNode(node)"
                                                    matTooltip="Rename">
                                                <mat-icon>edit_note</mat-icon>
                                            </button>
                                            <button mat-icon-button 
                                                    class="delete-node-button" 
                                                    (click)="deleteNode(node)"
                                                    matTooltip="Delete">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Child nodes -->
                                <div [class.tree-invisible]="!yearwiseTreeControl.isExpanded(node)"
                                    role="group">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                </div>
                            </mat-nested-tree-node>
                        </mat-tree>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
